var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopCompetitions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.78)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6A100",
    fillRule: "nonzero",
    d: "M9.78084022,18 L6.22038668,18 C8.97454584,16.7885194 8.97454584,9 8.97454584,9 L10.4662275,9 C10.4662275,9 10.4662275,16.7885194 13.2203867,18 L9.78084022,18 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 1,
    x: 3.22,
    y: 19,
    fill: "#606467",
    fillRule: "nonzero",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6A100",
    strokeWidth: 1.5,
    d: "M13.1315022,2 L20.1896798,2 C20.1896798,2 21.1579255,8 12.2203867,8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFC514",
    strokeWidth: 1.5,
    d: "M7.30927115,2 L0.251093563,2 C0.251093563,2 -0.71715218,8 8.22038668,8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC514",
    fillRule: "nonzero",
    d: "M3.22038668,0 L16.2203867,0 L16.2203867,2.85174457 C16.2203867,7.35167874 13.3101602,11 9.72073969,11 C6.13131918,11 3.22038668,7.3524029 3.22038668,2.85174457 L3.22038668,0 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 6.22,
    y: 17,
    fill: "#606467",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 9.22,
    y: 17,
    fill: "#424547",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424547",
    fillRule: "nonzero",
    d: "M9.22038668,19 L15.4426089,19 C15.8721637,19 16.2203867,19.2238576 16.2203867,19.5 L16.2203867,19.5 C16.2203867,19.7761424 15.8721637,20 15.4426089,20 L9.22038668,20 L9.22038668,19 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.72,
    cy: 4.5,
    r: 2.5,
    fill: "#D6A100",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCompetitions);
export default __webpack_public_path__ + "static/media/Top_competitions.c873bba38c755a0c895401c15f74d5e7.svg";
export { ForwardRef as ReactComponent };